'use strict';

angular.module('ntmApp').factory('ProfileActions', ['$location', 'ProfileHelper', 'GridService', 'ListGridStatus', 'ListGridHelper', 'ListGridConstants', 'ButtonExecution', 'RecurrenceModalsBridge', 'Utils', 'FormService', 'DataCollection', 'FlashService', 'ConfirmationService',
    function ($location, ProfileHelper, GridService, ListGridStatus, ListGridHelper, ListGridConstants, ButtonExecution, RecurrenceModalsBridge, Utils, FormService, DataCollection, FlashService, ConfirmationService) {

    function ProfileActions() {

        var self = this;

        self.runAction = function (button, data, recurrenceModel, callback) {

            switch (button.buttonType) {

                case ListGridConstants.ButtonActions.Execute:
                    if (button.methodName) {

                        var loading = FlashService.Loading();

                        ButtonExecution.RunMethod(button.methodName, data.model).then(function (result) {
                            loading.dismiss();

                          if (result.success)
                            FlashService.Success(result.data.message);

                            if (callback) {
                                callback(true);
                            }
                        });
                    }
                    break;

                case ListGridConstants.ButtonActions.OpenDialog:

                    var load = FlashService.Loading();

                    var requestData = {
                        id: button.redirectTo,
                        data: ListGridStatus.grid.infoTabModel
                    };

                    FormService.GetForm(requestData).then(function (result) {

                        load.dismiss();

                        if (!result.success) {
                            return;
                        }

                        var gridColumns = angular.copy(ListGridStatus.columns);

                        result.data.model = {};

                        result.data.generalPageSection.forEach(function (section) {
                            result.data.model = angular.extend(result.data.model, ListGridHelper.getModelByFieldName(section.sectionAttributes, ListGridStatus.grid.infoTabModel, 'fieldName', 'fieldName'));
                            if (data.gridRow) {
                                result.data.model = angular.extend(result.data.model, ListGridHelper.getModelByFieldName(section.sectionAttributes, data.gridRow.entity, 'name', 'fieldName'));
                            }
                        });

                        result.data.refreshGridData = refreshGridData;

                        Utils.OpenModal('', 'ng1/src/listGrid/views/openDialogForm.html', 'listGridOpenDialogController', result.data, 'setup-open-modal-dialog').result.then(function () {
                            ListGridStatus.columns = angular.copy(gridColumns);
                            if (callback) {
                                callback(true);
                            }
                        });
                    });

                    break;

                case ListGridConstants.ButtonActions.OpenPage:
                    $location.path(button.redirectTo);
                    break;

                case ListGridConstants.ButtonActions.Recurrence:
                    var modalsBridge = new RecurrenceModalsBridge();
                    var recurrenceData = getRecurrenceData(data.gridRow.entity);
                    modalsBridge.openRecurrenceDialog(recurrenceData, recurrenceModel, data.gridRow.entity, callback || self.callback);
                    break;

                case ListGridConstants.ButtonActions.DataCollections:
                    var entity = data.gridRow.entity;
                    entity.DataCollection = new DataCollection();
                    Utils.OpenModal('', 'ng1/src/setup/templates/dataCollectionView.html', 'DataCollectionController', entity, 'data-collection-dialog');
                    break;

                case 'SWITCH_ROOM':
                    ConfirmationService.YesNoConfirmation('All the current racks and activities will be hidden in the room before we proceed', null, { no: 'Cancel', yes: 'Confirm' })
                    .Yes(function () {
                        var data = {
                            keyFilters: ProfileHelper.entities,
                            callback: callback
                        };

                        Utils.OpenModal('', 'ng1/src/profilePages/dailySpeciesChanges/dailySpeciesChangesView.html', 'dailySpeciesChangesController', data, 'switch-room-species').result.then(function () {
                            
                        });
                    })
                    .Ask();
                    break;
            }
        };

        function refreshGridData() {
            var data = {
                sectionId: ListGridStatus.gridId,
                keyFilters: ProfileHelper.entities
            };

            GridService.GetSection(data).then(function (result) {
                if (result.success) {
                    ListGridStatus.columns.forEach(column => ListGridHelper.processingGridData(column, result.data.grid));
                    ListGridStatus.grid.gridOptions.data = result.data.grid;
                    ListGridStatus.originalGridData = angular.copy(ListGridStatus.grid.gridOptions.data);
                }
            });
        }

        function getRecurrenceData(row) {
            var recurrenceData = {};

            for (var property in row) {
                if (row.hasOwnProperty(property)) {
                    var column = ListGridHelper.getColumnByName(property);
                    if (column) {
                        recurrenceData[column.fieldName] = row[property];
                    }
                }
            }

            return recurrenceData;
        }
    }

    return (ProfileActions);
}]);
